import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getGeoCoordinates } from '../../../selectors/newbuilding';
import { getYandexStaticMapsUrl } from '../../../utils/config/getYandexStaticMapUrl';
import { useApplicationContext } from '../../../utils/withApplicationContext';

export function useMapPreviewUrl(width: number, height: number) {
  const { config, telemetry } = useApplicationContext();
  const yandexStaticMapsUrl = getYandexStaticMapsUrl(config);
  const coordinates = useSelector(getGeoCoordinates);

  const mapPreviewUrl = useMemo(() => {
    if (coordinates) {
      const { lat, lng } = coordinates;

      return `${yandexStaticMapsUrl}?ll=${lng},${lat}&size=${width},${height}&z=16&l=map`;
    }

    return null;
  }, [coordinates, height, width, yandexStaticMapsUrl]);

  /* istanbul ignore next */
  useEffect(() => {
    if (!mapPreviewUrl) {
      return;
    }

    telemetry.increment('static-maps.request');

    const image = new Image();

    image.src = mapPreviewUrl;

    image.onerror = () => {
      telemetry.increment('static-maps.error');
    };
  }, [mapPreviewUrl, telemetry]);

  return mapPreviewUrl;
}
